import { HStack, Spinner, Text } from "@chakra-ui/react"
import { Content } from "@pathwright/ui/src/components/content/Content"
import Checkbox from "@pathwright/ui/src/components/form/form-checkbox/Checkbox"
import PropTypes from "prop-types"
import { MetaText } from "../shared"

const AllowDownload = ({
  allowDownload,
  onChange,
  textColor,
  loading = false
}) => {
  return (
    <Content.Text>
      <MetaText
        style={{
          color: textColor
        }}
      >
        Allow learner to download this media?
        {loading ? (
          <HStack ml={2}>
            <Spinner
              borderRightColor="rgb(41, 46, 53)"
              borderTopColor="rgb(41, 46, 53)"
            />{" "}
            <Text fontSize="small" color="rgb(41, 46, 53)" fontStyle="italic">
              Fetching download...
            </Text>
          </HStack>
        ) : (
          <Checkbox
            style={{ marginLeft: "0.5rem", marginTop: "-1px" }}
            checked={allowDownload}
            onChange={onChange}
          />
        )}
      </MetaText>
    </Content.Text>
  )
}

AllowDownload.propTypes = {
  allowDownload: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  textColor: PropTypes.string
}

export default AllowDownload
